export default {
  base: 16,
  ratio: 1.618,
  subSequence: true,
}
